import qs from 'qs';
import BaseHttp from '@/plugins/baseHttp';


const createStoreGrid = (franchiseId, payload,) => {
  BaseHttp.setFranchise(franchiseId,);

  return BaseHttp.post('/franchises/store-grids', payload,);
};

const updateStoreGrid = (franchiseId, storeGridId, payload,) => {
  BaseHttp.setFranchise(franchiseId,);

  return BaseHttp.patch(
    `/franchises/store-grids/${storeGridId}`,
    payload,
  );
};

const updateStoreGridEnabled = (franchiseId, storeGridId, payload,) => {
  BaseHttp.setFranchise(franchiseId,);
  return BaseHttp.patch(`/franchises/store-grids/${storeGridId}/enabled`, payload,);
};

const deleteStoreGrid = (franchiseId, storeGridId,) => {
  BaseHttp.setFranchise(franchiseId,);
  return BaseHttp.delete(`/franchises/store-grids/${storeGridId}`,);
};

const getStoreGridsByCity = (franchiseId, params = {},) => {
  const queryString = qs.stringify(params, { skipNulls: true, },);
  const query = queryString ? `?${queryString}` : '';

  if (franchiseId) {
    BaseHttp.setFranchise(franchiseId,);
  }

  return BaseHttp.get(`/franchises/store-grids${query}`,);
};

const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  createStoreGrid,
  updateStoreGrid,
  updateStoreGridEnabled,
  deleteStoreGrid,
  getStoreGridsByCity,
  handleError,
};
